import styled from "styled-components";


export const ButtonsContainer = styled.div(props => ({
    width:"100%",
    marginLeft:"25%",
    "& .buttonSendReset" :{
        marginBottom:"5px"
    },
    
    '& p':{
    color: 'gray',
     marginTop: '10px' 
  }
  }))